import {ApolloClient} from 'apollo-client';
import {ApolloLink, Observable} from 'apollo-link';
import {BatchHttpLink} from 'apollo-link-batch-http';
import {onError} from 'apollo-link-error';
import {InMemoryCache, defaultDataIdFromObject, IntrospectionFragmentMatcher} from 'apollo-cache-inmemory';
import graphQLError2Str from './utils/graphql-error-2-str';
import checkedCacheIdFromObject from './utils/checked-cache-id-from-object';
import forceAuthentication from './utils/force-authentication';
import config from './config';
import {setContext} from 'apollo-link-context';
import {getUser} from './components/app/AppNavigation';
import introspectionQueryResultData from './fragmentTypes.json';

// add names of errors which should not show up as notification
// could also implemented as included process - show only errors...
const errors2Skip = [
  /*'ErrorToSkip'*/
];

const authLink = setContext(() => (getUser() ? {headers: {authorization: getUser()}} : {}));

const errorLink = onError(errors => {
  if (!forceAuthentication(errors, client)) {
    return new Observable(() => {});
  }
  const errorStr = graphQLError2Str(errors, errors2Skip);
  if (errorStr) console.log('Todo: show error'); // Todo: show error
});

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData,
});

const dataIdFromObject = checkedCacheIdFromObject(
  {
    // Article: ['id', 'version'],
  },
  defaultDataIdFromObject
);

const cache = new InMemoryCache({dataIdFromObject, fragmentMatcher});

const httpLink = new BatchHttpLink({
  uri: `${config.apiUrl}/graphql`,
  credentials: 'same-origin',
});

const link = ApolloLink.from([authLink, errorLink, httpLink]);

const client = new ApolloClient({link, cache});

export default client;
